import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';
import ptTranslation from './locales/pt/translation.json';

const userLang = navigator.language || navigator.userLanguage;
const locale = userLang && userLang !== '' ? userLang.substring(0, 2) : 'en';

i18n.use(initReactI18next).init({
  lng: locale,
  fallbackLng: 'en',
  react: {
    wait: false,
    useSuspense: false,
  },
});

i18n.addResourceBundle('en', 'translation', enTranslation);
i18n.addResourceBundle('es', 'translation', esTranslation);
i18n.addResourceBundle('pt', 'translation', ptTranslation);

export default i18n;
